import { getTripleID } from "./common"
const trackCouponClickEvent = code => {
  if (window?.dataLayer) {
    window.dataLayer.push({
      event: "coupon_code_submission",
      coupon_code: code,
      ...getTripleID()
    })
  }
}

export { trackCouponClickEvent }
